// extracted by mini-css-extract-plugin
export default {"scottSecretSantaApp":"ResultListBody_scottSecretSantaApp__cuKu9","resultListBody":"ResultListBody_resultListBody__44nfa","title":"ResultListBody_title__3f4Cz"};